import { Anchor, ArrowRight } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";

export function PortsCTA() {
  const { t } = useLang();
  return (
    <section data-testid="ports-cta-section" className="relative py-20 md:py-24">
      <div className="mx-auto max-w-5xl px-5 md:px-8">
        <Reveal>
          <div className="relative glass overflow-hidden p-10 md:p-14 text-center border-[#C9A227]/30" style={{ borderRadius: "4px 32px 4px 32px" }}>
            <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse 60% 60% at 50% 0%, rgba(201,162,39,0.10), transparent 65%)" }} aria-hidden="true" />
            <div className="relative">
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-[#C9A227]/40 bg-[#C9A227]/10 text-[#C9A227]">
                <Anchor size={24} />
              </span>
              <h2 className="mt-6 font-display text-3xl md:text-4xl text-[#F5F7FA]">{t.ports.title}</h2>
              <p className="mx-auto mt-3 max-w-xl text-sm md:text-base text-[#EDF1F6]">{t.ports.subtitle}</p>
              <button
                data-testid="ports-cta-button"
                onClick={() => window.dispatchEvent(new CustomEvent("mx:ports-click"))}
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#C9A227] px-9 py-4 text-sm font-bold tracking-[0.15em] text-[#07111F] hover:bg-[#F5F7FA] hover:shadow-[0_0_30px_rgba(201,162,39,0.4)] hover:-translate-y-0.5 transition-[background-color,box-shadow,transform] duration-300"
              >
                {t.ports.navLabel} <ArrowRight size={16} />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
